<template>
  <div>
    <nav-header :title="$t('communityHelper.name')" />
    <div class="body-wrapper" v-if="!isLoaded">
      <md-skeleton></md-skeleton>
      <md-skeleton></md-skeleton>
      <md-skeleton :row="5"></md-skeleton>
    </div>
    <div class="body-wrapper" v-else>
      <div class="pane">
        <div class="pane-title">展示广告</div>
        <div class="pane-content">
          <md-field-item @click="onPopupShowChange(true)">
            <span :class="{ inactive: !popupItems[prevCurrent] }">
              {{
                (popupItems[prevCurrent] && popupItems[prevCurrent].text) ||
                  '默认仅展示公开广告'
              }}
            </span>
            <span class="icon-dropdown" slot="right"></span>
          </md-field-item>
        </div>
      </div>
      <div class="division"></div>
      <div class="pane">
        <div class="pane-title">用户管理</div>
        <div class="pane-content">
          <p class="tips">
            提示：新增用户或者移除用户后，请手动尝试刷新群用户信息，否则用户不能正常交易。
          </p>
          <md-button
            :type="isSubmitting ? 'disabled' : 'primary'"
            :loading="isSubmitting"
            @click="onUpdateClicked"
          >
            <span v-if="isSubmitting">刷新中...</span>
            <span v-else>刷新群用户信息</span>
          </md-button>
        </div>
      </div>
      <div class="division"></div>
      <div class="pane">
        <div class="pane-title row-justify-center">
          <span>展示币种</span>
          <span class="link row-center" @click="goEdit">
            <span>编辑</span>
            <md-icon name="arrow-right" size="sm"></md-icon>
          </span>
        </div>
        <div class="pane-content">
          <p
            class="empty-text row-center"
            v-if="!communitySettings.choose.length"
          >
            默认展示所有币种
          </p>
          <ol class="symbol-list" v-else>
            <li
              class="item row-align-center"
              v-for="item in communitySettings.choose"
              :key="item.id"
            >
              <img class="img" :src="item.icon" :alt="item.name" />
              <span class="text">{{ item.name }}</span>
            </li>
          </ol>
        </div>
      </div>
    </div>

    <!-- 展示广告  -->
    <md-popup v-model="isPopupShow" position="bottom" preventScroll>
      <md-popup-title-bar
        title="请选择展示的广告类型"
        large-radius
        :cancel-text="$t('common.cancel')"
        :ok-text="$t('common.confirm')"
        @cancel="onPopupShowChange(false)"
        @confirm="onPopupConfirm"
      ></md-popup-title-bar>
      <div class="popup-content">
        <div class="list">
          <div
            class="item row-justify-center"
            v-for="(item, index) in popupItems"
            :key="index"
            @click="onChoose(index)"
          >
            <div class="item-left">{{ item.text }}</div>
            <div class="item-right">
              <md-icon
                name="right"
                size="lg"
                v-if="index === current"
              ></md-icon>
            </div>
          </div>
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import navHeader from '@/components/the-nav-bar.vue';
import { mapState } from 'vuex';
import { postUserCommunitySettings, postUserCommunity } from '@/api/user';
import {
  Skeleton,
  Switch,
  Icon,
  Button,
  FieldItem,
  Popup,
  PopupTitleBar,
  Toast,
  Dialog,
} from 'mand-mobile';
export default {
  components: {
    navHeader,
    [Skeleton.name]: Skeleton,
    [Switch.name]: Switch,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
  },
  data() {
    return {
      isLoaded: false,
      isPopupShow: false,
      popupItems: [
        {
          value: 1,
          text: '只展示群主广告',
        },
        {
          value: 2,
          text: '展示群成员广告',
        },
      ],
      current: -1,
      prevCurrent: -1,
      isSubmitting: false,
    };
  },
  computed: mapState({
    env: state => state.env,
    settings: state => state.settings,
    communitySettings: state => state.communitySettings,
    assetMap() {
      const map = {};
      this.settings.cryptoList.forEach(item => {
        map[item.uuid] = item;
      });
      return map;
    },
  }),
  mounted() {
    let promise = this.$store.dispatch('updateUserCommunitySettings');
    if (this.communitySettings.loadStatus === 'success') {
      this.isLoaded = true;
    }
    promise
      .then(() => {
        this.isLoaded = true;
        this.current = this.prevCurrent = this.communitySettings.property - 1;
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
  methods: {
    onPopupShowChange(val) {
      this.isPopupShow = val;
    },
    onPopupConfirm() {
      if (this.prevCurrent !== this.current) {
        //
        Toast.loading(this.$t('common.loading'));
        postUserCommunitySettings(
          this.env.conversationId,
          this.communitySettings.choose.map(item => item.id),
          this.popupItems[this.current].value,
        )
          .then(() => {
            Toast.hide();
            this.isPopupShow = false;
            this.prevCurrent = this.current;
          })
          .catch(err => {
            Toast.hide();
            Dialog.alert({
              title: err.message,
              confirmText: this.$t('common.confirm'),
            });
          });
      } else {
        this.isPopupShow = false;
      }
    },
    onChoose(index) {
      this.current = index;
    },
    onUpdateClicked() {
      this.isSubmitting = true;
      postUserCommunity(this.env.conversationId)
        .then(() => {
          Toast.succeed('刷新成功');
          this.isSubmitting = false;
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            title: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    goEdit() {
      this.$router.push('/mine/communityHelper/editSymbol');
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding-bottom: 40vw;

  .md-skeleton {
    margin: 9.6vw 4.8vw;
  }
}

.pane {
  padding: 4.8vw;

  .pane-title {
    margin-bottom: 4.8vw;
    font-size: 3.2vw;
    color: color-text-caption;
  }
}

.division {
  height: 1px;
  background: #EAF1F3;
}

.md-field-item {
  padding: 0 4.27vw;
  border: 0.27vw solid #EAF1F3;
  border-radius: 2.67vw;
  background: #F8FBFC;

  .icon-dropdown {
    border-top: 1.8vw solid color-text-base;
    border-left: 1.6vw solid transparent;
    border-right: 1.6vw solid transparent;
    width: 0;
    height: 0;
  }

  .inactive {
    color: color-text-caption;
  }

  >>> .md-field-item-content:before {
    content: none;
  }
}

.tips {
  margin: 4.8vw 0;
}

.link {
  color: color-primary;
}

.empty-text {
  min-height: 30vw;
  color: color-text-caption;
}

.symbol-list {
  .item {
    margin: 4.8vw 0;
    height: 6.4vw;
    line-height: 6.4vw;
    font-size: 3.73vw;
    font-weight: bold;

    .img {
      width: 6.4vw;
      height: 6.4vw;
    }

    .text {
      margin: 0 2.13vw;
      flex: 1 0 0;
      color: color-text-caption;
    }
  }
}

.popup-content {
  padding: 4.8vw 6.4vw 16vw;
  background: #fff;

  .item {
    position: relative;
    min-height: 13.33vw;
    hairline(bottom);

    .item-left {
      font-size: 3.73vw;
    }

    .item-right {
      color: color-primary;
    }
  }
}
</style>
